import React from "react";
import { Box } from "@mui/material";

interface StatusBadgeProps {
  label: "Active" | "Standby" | string;
  icon?: React.ReactNode;
  isActive?: boolean;
}

const StatusButton: React.FC<StatusBadgeProps> = ({ label, isActive, icon }) => {
  return (
    <Box className="status-button-container">
      <Box className={`status-button-inner ${isActive ? "active" : ""}`}>
        {icon? icon: label}
      </Box>
    </Box>
  );
};

export default StatusButton;